<div class="layout-footer">
  <span class="font-medium ml-2">Copyright © AmigoFarma 2023 Todos los derechos reservados</span>
</div>
